"use client";

import { createIcon } from "@chakra-ui/react";

const DeliveryTruckSvgIcon = createIcon({
  displayName: "DeliveryTruckSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill={'none'}
      d="M3 18H1V3H14V17M3 18C3 17.2044 3.31607 16.4413 3.87868 15.8787C4.44129 15.3161 5.20435 15 6 15C6.79565 15 7.55871 15.3161 8.12132 15.8787C8.68393 16.4413 9 17.2044 9 18M3 18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21C6.79565 21 7.55871 20.6839 8.12132 20.1213C8.68393 19.5587 9 18.7956 9 18M14 18H9M14 18C14 17.2044 14.3161 16.4413 14.8787 15.8787C15.4413 15.3161 16.2044 15 17 15C17.7956 15 18.5587 15.3161 19.1213 15.8787C19.6839 16.4413 20 17.2044 20 18M14 18C14 18.7956 14.3161 19.5587 14.8787 20.1213C15.4413 20.6839 16.2044 21 17 21C17.7956 21 18.5587 20.6839 19.1213 20.1213C19.6839 19.5587 20 18.7956 20 18M20 18H23V13L19 8H14"
      stroke="black" strokeWidth="2" />
  ),
});

export default DeliveryTruckSvgIcon;
